import React from "react";
import "./Loading.css";

const Loading = () => {
  return (
    <div className="loading">
      <h1>Please wait a moment...</h1>
    </div>
  );
};

export default Loading;
